import React from "react";
import { TIME_RANGE_OPTIONS, TimeRangeKey } from "../utils/dateRange";

interface Props {
  value: TimeRangeKey;
  onChange: (key: TimeRangeKey) => void;
}

// Shared time-range pill bar used across the money-over-time admin tabs
// (Dashboard, Revenue, All Payouts). The selected window is owned by the parent
// (AdminDashboard) and passed in, so it persists as the admin moves between
// those tabs. Display-only: choosing a window only changes which already-loaded
// records get summed, never how anything is stored. Reuses the existing
// `.filter-chip` styling so it matches the rest of the admin UI.
export default function TimeRangeBar({ value, onChange }: Props) {
  return (
    <div className="adm-range-bar">
      <span className="adm-range-label">Showing</span>
      <div className="adm-range-pills">
        {TIME_RANGE_OPTIONS.map((opt) => (
          <button
            key={opt.key}
            type="button"
            className={`filter-chip ${value === opt.key ? "active" : ""}`}
            title={opt.title}
            onClick={() => onChange(opt.key)}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
